module.exports = __webpack_public_path__ + "img/dwb_mobile_poster.a3c72e39.png";